import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import type { ComponentData } from './../../ricos-types';
import { withEditorEvents } from './../../editor-common/EditorEventsContext';

import { PollContextProvider } from '../components/poll-context/PollContext';
import { RCEHelpersContext } from '../components/rce-helpers-context';
import type { PollPluginViewerConfig } from '../types';
import { Poll } from './poll-component';

interface Props {
  componentData: ComponentData;
  selected: boolean;
  settings: PollPluginViewerConfig;
  updateAttributes?: (attributes: $TSFixMe) => void;

  editorEvents: any;
  isViewMode?: boolean;

  helpers: any;
}

const Polls: React.FC<Props> = props => {
  const { theme, t, isMobile } = useContext(RicosContext);

  const setPoll = (poll: $TSFixMe) => {
    const { updateAttributes } = props;
    updateAttributes?.({ poll });
  };

  const { componentData, helpers, editorEvents, selected, isViewMode = false, settings } = props;

  return (
    <RCEHelpersContext.Provider
      value={{
        isViewMode: isViewMode
          ? isViewMode
          : settings.isWebView || typeof selected === 'boolean'
          ? !selected
          : true,
        setInPluginEditingMode: () => {},
        layout: componentData.layout,
        design: componentData.design,
        preventVoting: !isViewMode,
        isPreview: isMobile,
        helpers,
        theme,
        t,
        isMobile,
        ...settings,
      }}
    >
      <PollContextProvider
        editorEvents={editorEvents}
        settings={settings}
        poll={componentData.poll}
        setPoll={setPoll}
        t={t}
      >
        <Poll />
      </PollContextProvider>
    </RCEHelpersContext.Provider>
  );
};

export default withEditorEvents(Polls);
